import React from 'react';

import { Box, CircularProgress } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PreviewIcon from '@mui/icons-material/Preview';
import SendIcon from '@mui/icons-material/Send';

import MyButton from '../Button/MyButton';
import { useTranslation } from 'react-i18next';
import { selectBackgroundColor } from '@common/providers/ThemeProvider/selectors';

export default function FormActionButtons({
  onSave = () => {},
  onSend = () => {},
  onCancel = () => {},
  onPreview = () => {},
  isCustomEmail,
  isSubmitting,
}) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        bottom: '0px',
        position: 'absolute',
        p: '0px 0px',
        display: 'flex',
        width: '98%',
        zIndex: 1,
        backgroundColor: selectBackgroundColor,
      }}
    >
      {!isCustomEmail && (
        <MyButton
          variant='outlined'
          color='error'
          onClick={onCancel}
          startIcon={<HighlightOffIcon />}
          size={'small'}
        >
          {t('cancel')}
        </MyButton>
      )}

      <MyButton
        variant='outlined'
        onClick={onPreview}
        sx={{
          ml: 'auto',
          pl: '1rem',
          pr: '1rem',
        }}
        startIcon={<PreviewIcon />}
        size={'small'}
      >
        {t('preview_button')}
      </MyButton>
      {isCustomEmail ? (
        <MyButton
          disabled={isSubmitting}
          onClick={onSend}
          variant='outlined'
          color='primary'
          startIcon={
            isSubmitting ? <CircularProgress size={20} /> : <SendIcon />
          }
          sx={{ mr: 2, pl: '1rem', pr: '1rem' }}
          size={'small'}
        >
          {t('send_button')}
        </MyButton>
      ) : (
        <MyButton
          onClick={onSave}
          variant='outlined'
          color='primary'
          startIcon={<SaveIcon />}
          sx={{
            ml: 'auto',
            mr: '5px',
            minWidth: '115px',
            pl: '1rem',
            pr: '1rem',
          }}
          size={'small'}
        >
          {t('save_button')}
        </MyButton>
      )}
    </Box>
  );
}
